import { paymentDetail } from './request';
export default {
  data() {
    return {
      dataFrom: {},
      dialogVisible: false
    };
  },
  computed: {
    payStatusName() {
      return this.$t(this.dataFrom.payStatusName);
    },
    payTypeName() {
      return this.$t(this.dataFrom.payTypeName);
    },
    typeName() {
      return this.$t(this.dataFrom.typeName);
    }
  },
  methods: {
    init(id) {
      paymentDetail({
        orderId: id
      }).then(res => {
        console.log(res);
        this.dataFrom = res;
      });
      this.dialogVisible = true;
    }
  }
};